import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useAddressProfit } from '@/hooks/api/useAddressProfit';
import { formatBalanceWithCommas, formatPercentage, formatTextEllipsis } from '@/lib/format';
import { cn, genJudgingSizeColor } from '@/lib/utils';
import { useAppStore } from '@/store';
import { useBoomWallet } from '@boomeme/wallet-sdk';
import { useTranslation } from 'react-i18next';

type TIME = '7d' | '30d';

export default () => {
  const { fwClass, totalBalance, setDepositOpen } = useAppStore();
  const { walletAddress } = useBoomWallet();
  const { t } = useTranslation();
  const { profit, setTimeRange } = useAddressProfit();

  return (
    <Card className="bg-[#F4F4F5CC] dark:bg-[#27272ACC] !border-none shadow-none p-[12px] rounded-[8px] mt-[20px]">
      <CardContent className="p-0 flex justify-between items-center">
        <div className="flex flex-col gap-y-[6px]">
          <div>
            <span className="text-[14px] font-[400]">{t('Token.balance')}</span>{' '}
            <span className="text-[12px] text-secondaryTextColor">{`(${formatTextEllipsis(walletAddress || '')})`}</span>
          </div>
          <h1 className={cn('text-[24px]', fwClass)}>{formatBalanceWithCommas(totalBalance)}</h1>
          <div className="flex items-center  gap-x-[6px]">
            <span className={cn('text-[12px] font-[400]', genJudgingSizeColor(profit.pnl))}>
              {formatBalanceWithCommas(profit.pnl)}({formatPercentage(profit.roi, { scale: true })})
            </span>
            <div>
              <Select onValueChange={(e: string) => setTimeRange(e as TIME)}>
                <SelectTrigger className="h-[22px] px-[4px] pl-[8px] py-[2px] bg-primaryBgColor rounded-[6px]">
                  <SelectValue
                    className="bg-[#fff] w-full h-full text-[12px] font-[400] border-[1px] border-[#E4E4E7] dark:border-[#27272A]"
                    placeholder={t('Token.7D')}
                  />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectItem value="7d">{t('Token.7D')}</SelectItem>
                    <SelectItem value="30d">{t('Token.30D')}</SelectItem>
                  </SelectGroup>
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>
        <Button
          className={cn('!bg-themeColor text-primaryTextColor w-[85px] h-[40px] font-[400] rounded-[12px]', fwClass)}
          onClick={() => setDepositOpen(true)}
        >
          {t('Token.deposit')}
        </Button>
      </CardContent>
    </Card>
  );
};
